import React from 'react';
import './SettingsOverlay.css';

interface SettingsOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  settings: {
    theme: string;
    notificationSounds: boolean;
  };
  onToggleSetting: (setting: string) => void;
  onChangeTheme: (theme: string) => void;
}

const THEMES = [
  { id: 'warm-beige', name: 'Warm Beige', preview: '#f4f0ea' },
  { id: 'dark', name: 'Dark', preview: '#2c2420' },
  { id: 'ocean', name: 'Ocean', preview: '#1a4b8c' },
  { id: 'mono', name: 'Monochrome', preview: '#f5f5f5' },
];

const SettingsOverlay: React.FC<SettingsOverlayProps> = ({ isOpen, onClose, settings, onToggleSetting, onChangeTheme }) => {
  if (!isOpen) return null;

  return (
    <div className="settings-overlay">
      <div className="settings-overlay-backdrop" onClick={onClose}></div>
      <div className="settings-overlay-panel">
        <div className="settings-overlay-header">
          <h2>Settings</h2>
          <button className="settings-close-btn" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div className="settings-overlay-content">
          <div className="settings-section">
            <h3>Theme</h3>
            <div className="settings-theme-grid">
              {THEMES.map((theme) => (
                <button
                  key={theme.id}
                  className={`settings-theme-option ${settings.theme === theme.id ? 'active' : ''}`}
                  onClick={() => onChangeTheme(theme.id)}
                >
                  <div className="settings-theme-swatch" style={{ background: theme.preview }} />
                  <span className="settings-theme-name">{theme.name}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="settings-section">
            <h3>Notifications</h3>
            <div className="settings-list">
              <div className="settings-item">
                <label className="settings-toggle">
                  <input
                    type="checkbox"
                    checked={settings.notificationSounds}
                    onChange={() => onToggleSetting('notificationSounds')}
                  />
                  <span className="settings-toggle-slider"></span>
                </label>
                <div className="settings-info">
                  <span className="settings-name">Notification Sounds</span>
                  <span className="settings-desc">Play sound when AI responds (only when tab is inactive)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsOverlay;
